import styled from 'styled-components';
import { Box } from './DockLikuController.style';

export const RobotStateBox = styled(Box)`
	min-height: 4rem;
	${({ theme }) => theme.common.wh('100%', '4rem')};

	.title {
		//padding: 0.8rem
		border-radius: 12px;
	}

	.wrap {
		gap: 0.9rem;
		${({ theme }) => theme.common.flex()};
	}

	.stateWrap {
		border-radius: 4px;
		background-color: #000;
		${({ theme }) => theme.common.flex()};
	}
`;

export const StateButton = styled.button`
	background-color: transparent;
	border: none;
	border-radius: 4px;
	box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
	font-family: NotoSansKR-Regular;
	font-size: 1.5rem;
	font-weight: normal;
	font-stretch: normal;
	font-style: normal;
	line-height: 2;
	letter-spacing: normal;
	text-align: center;
	color: ${({ theme }) => theme.color.subTitle};

	${({ theme }) => theme.common.flex()};
	${({ theme }) => theme.common.wh('5.75rem', '2.75rem')};

	${({ theme, click }) =>
		click &&
		`background-color: #fff;
		 color: #000;
		 border: solid 1px ${theme.color.gray_35}`};

	@media (max-width: 1000px) {
		font-size: 1.2rem;
		${({ theme }) => theme.common.wh('4.6rem', '2.2rem')};
	}
`;

export const VolumeControl = styled.div`
	display: flex;
	align-items: center;
	gap: 0.6rem;
	padding: 0 0.8rem;
	color: #fff;

	> svg {
		width: 1.8rem;
		height: 1.8rem;
		flex-shrink: 0;
	}
`;

export const VolumeSliderWrap = styled.div`
	position: relative;
	width: 7rem;
	height: 2.4rem;

	&& input[type='range'] {
		appearance: none;
		display: block;
		width: 100%;
		height: 100%;
		margin: 0;
		padding: 0;
		background: transparent;
		cursor: pointer;

		&:focus-visible {
			outline: 2px solid #fff;
			outline-offset: 3px;
		}

		&::-webkit-slider-runnable-track {
			height: 4px;
			border-radius: 2px;
			background: #888;
		}

		&::-moz-range-track {
			height: 4px;
			border-radius: 2px;
			background: #888;
		}

		&::-webkit-slider-thumb {
			appearance: none;
			width: 14px;
			height: 14px;
			margin-top: -5px;
			border: none;
			border-radius: 50%;
			background: #fff;
		}

		&::-moz-range-thumb {
			width: 14px;
			height: 14px;
			border: none;
			border-radius: 50%;
			background: #fff;
		}
	}

	.volumeTooltip {
		position: absolute;
		bottom: calc(100% + 4px);
		left: calc(7px + (100% - 14px) * var(--volume) / 100);
		transform: translateX(-50%);
		z-index: 1;
		padding: 0.2rem 0.6rem;
		border-radius: 4px;
		background: #fff;
		color: #000;
		font-size: 1.2rem;
		line-height: 1.5;
		pointer-events: none;
		visibility: hidden;
	}

	&:hover .volumeTooltip,
	&:focus-within .volumeTooltip {
		visibility: visible;
	}
`;

export const VolumeButton = styled.button`
	background-color: transparent;
	border: none;
	border-radius: 4px;
	font-family: NotoSansKR-Regular;
	font-size: 1.2rem;
	font-weight: normal;
	font-stretch: normal;
	font-style: normal;
	line-height: 2;
	letter-spacing: normal;
	text-align: center;
	color: #fff;
	background-color: ${({ theme }) => theme.color.gray_35};
	${({ theme }) => theme.common.flex()};
	${({ theme }) => theme.common.wh('4rem', '2.4rem')};
`;
